import React, { useState, useEffect } from 'react'

const classNames = (...clases) => {
  return clases.filter(Boolean).join(" ")
}

const InputNumerText = ({ label='', values, setValue, name, enabled, type, required = false, tryToSave=false, handleBlur=()=>{}, setErrors=()=>{}}) => {

  const [isValidPhone, setIsValidPhone] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const re = /^[a-zA-Z0-9_]+$/;
  let regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  function ver(texto){
    try { 
      console.log('valido')
      return regex.exec(texto)[0]?false:true
    } catch (error) {
      console.log('invalido')
      return true
    }
  }

  useEffect(() => {
  
  console.log(required, isValidPhone)
  }, [isValidPhone])
  
  

  return (
    <div className='flex flex-col w-full'>
    <label className='text-white'>{label}</label>
        <input className={classNames(!enabled ? 'bg-white' : 'bg-gray-400', 'rounded-md p-2')}
          minlength={type==="tel" && "8"}
          maxLength={type==="tel" && "8"}
          //pattern={type==="text" && "\w[A-Z]"}
          onBlur={handleBlur}
          disabled={enabled}
          name={name}
          type={type} 
          inputMode={type==="tel" && "numeric"}
          value={values[name] || ""} 
          onChange={(e) => {
          setValue({...values, [e.target.name]:e.target.value}); 
          type==="tel" && e.target.value.length < 8 ? setIsValidPhone(true): setIsValidPhone(false);
          type==="email" && setIsValidEmail(ver(e.target.value))
        }
        }
          ></input>
        {(tryToSave && required) && <p className='text-secundario'>Dato obligatorio</p>}
        {(!required && isValidPhone  && type==="tel") && <p className='text-secundario'>Debe ser de 8 dígitos</p>}
        {(!required && isValidEmail  && type==="email") && <p className='text-secundario'>Email inválido</p>}
        {(type==="number" && name === 'E_DPI') && values[name]?.length < 13 &&  <p className='text-secundario'>DPI inválido</p>}
        {(type==="number" && name === 'E_Edad') && values[name]?.length > 2 &&  <p className='text-secundario'>Edad inválida</p>}
        {(type==="number" && name === 'E_DPI') && values[name]?.length < 13 ?  setErrors(true): setErrors(false)}
        {(type==="number" && name === 'E_Edad') && values[name]?.length > 2 ?  setErrors(true): setErrors(false)}
        {(!required && isValidPhone  && type==="tel")   ? setErrors(true): setErrors(false)}
        {(!required && isValidEmail  && type==="email") ? setErrors(true): setErrors(false)}
        
    </div>
  )
}

export default InputNumerText